import React, { useEffect, useState, useMemo } from 'react';
import { useIntl } from 'react-intl';
import RouteList from './components/routeList'
import { useDispatch, useSelector } from "react-redux";
import { Grid, ListItemIcon, Divider, ListItemText, ListItem, List, Container, Typography, Avatar } from "@mui/material";
import { Toolbar, Button } from 'Components/uiControls';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Select } from 'Components';
import moment from 'moment';
import { Loading } from 'Components';
import InputSearch from 'Components/InputSearch';


import './index.scss';

//Map
import { useSidePanelMap , useRealtimeDrivers} from 'Core/hooks';

import {
    searchStop,
    updatePositionStop,
    openStopDelete,
    openStopCreateEdit,
    openStopImport
} from 'Redux/actions';

//View
import RouteDelete from './components/delete';
import RouteCreateEdit from './components/createEdit';
import ImportRoute from './components/importRoute';
import FsmAvatarDriver from '../main/components/avatarDriver';
import { getLastConnection } from '../main/tools/getLastConn';
import { NotificationManager } from 'Components/Notifications';


const FsmRoutes = () => {

    const dispatch = useDispatch();

    const { messages, locale } = useIntl();
    const [SideMapComponent, onToggleSideMap] = useSidePanelMap()

    const optionsFilterDrivers = [{ id: 'all', name: messages['FSM_SETTINGS_MESSAGES_DRIVER_ALL'] }, { id: 'connected', name: messages['FSM_SETTINGS_MESSAGES_DRIVER_CONNECTED'] }]
    const optionsColum = [
        { id: 3, name: messages['FSM_SETTINGS_ROUTE_ON_SITE'] },
        { id: 2, name: messages['FSM_SETTINGS_ROUTE_ON_ROUTE'] },
        { id: 1, name: messages['FSM_SETTINGS_ROUTE_PENDING'] },
        { id: 4, name: messages['FSM_SETTINGS_ROUTE_DONE'] }
    ];
    const [columns, setColumns] = useState([]);
    const [namePreview, setNamePreview] = useState('');
    const [lisDrivers, setLisDrivers] = useState([]);
    const [filterConnected, setFilterConnected] = useState(optionsFilterDrivers[0]);
    const [driverSelected, setDriverSelected] = useState({});
    const [itemsSelected, setItemsSelected] = useState([]);
    const [searchText, setSearchText] = useState('');
    const { user: { dateformat } } = useSelector((state) => state.securityRedux);

    //get the information for drivers from catalog
    const allDrivers = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });
    
    const TimeCardDrivers = useMemo(() => {
        return allDrivers?.filter(driver => driver.fsmDriver === true) || [];
    }, [allDrivers]);
    const loadingTimeCardDrivers = useSelector(state => state.catalogsRedux.loadingDrivers);

    const {
        Stops,
        loading
    } = useSelector(state => state.RoutesRedux);



    const fsmNomadPushNotification = useSelector(state => state.catalogsRedux.fsmNomadPushNotification);




    const onDragEnd = (result, columns, setColumns) => {
        if (!result.destination) return;

        const { source, destination } = result;

        const [removed] = columns[source.droppableId]?.items?.splice(source.index, 1);
        columns[destination.droppableId]?.items?.splice(destination.index, 0, removed);
        let updateStops = [];
        columns[destination.droppableId]?.items?.forEach((element, index) => {
            updateStops.push({
                id: element.id,
                statusId: columns[destination.droppableId]?.id,
                sequence: index
            })
        });

        if (updateStops.length > 0)
            dispatch(updatePositionStop(updateStops))

        setColumns(columns);
    };

    useEffect(() => {

        if (!Stops?.error && Stops?.stops?.items?.length > 0) {
            let newStops = [];
            columns?.forEach((element) => {
                let files = Stops?.stops?.items.filter(item => item.statusId == element.id)
                newStops.push({
                    ...element,
                    items: files
                })
            });

            setColumns(newStops)
        }
    }, [Stops]);

    useEffect(() => {
        setColumns(optionsColum)
    }, []);

    useEffect(() => {
        if (fsmNomadPushNotification?.Entity === "nomadOptimizeStops" || fsmNomadPushNotification?.Entity === "nomadStopStatusUpdate" || fsmNomadPushNotification?.Entity === "nomadStopUpdate" || fsmNomadPushNotification?.Entity === "nomadMultipleStopsUpdate" || fsmNomadPushNotification?.Entity === "nomadStop" ) {
            if (driverSelected?.driverId) {
                dispatch(searchStop(driverSelected?.driverId, true))
            }
        }
    }, [fsmNomadPushNotification]);


    useEffect(() => {
        if (TimeCardDrivers?.length > 0) {
            setLisDrivers(TimeCardDrivers)
        }
    }, [TimeCardDrivers]);

    const handleSearch = (text) => {
        setSearchText(text)
        let newFilter = TimeCardDrivers?.filter((item) => item.name.toLowerCase().includes(text.toLowerCase()))

        if (filterConnected?.id && filterConnected?.id === 'connected') {
            newFilter = newFilter?.filter((item) => item.connected == 1)
        }

        setLisDrivers(newFilter)
    };

    const openMap = (location) => {
        const { name, latitude, longitude } = location
        const lat = parseFloat(latitude)
        const long = parseFloat(longitude)
        if(isNaN(lat) || isNaN(long)){
            return NotificationManager.error(
                messages['FSM_SETTINGS_ROUTE_LAT_LONG_WRONG'],
                messages["error"],
                3000,
                null,
                null,
                "warning"
            )
        }
        setNamePreview(location.name)
        onToggleSideMap(true, [{ latitude: lat, longitude: long, direction: 35, heading: '1', Label: name }])
    }

    useEffect(() => {
        handleSearch(searchText)
    }, [filterConnected]);

    const checkedItem = (checked, item) => {

        let newSelectedRows = [];
        if (checked) {
            newSelectedRows = [...itemsSelected];
            newSelectedRows.push(item);
        } else {
            newSelectedRows = itemsSelected.filter(selectedRow => selectedRow.id !== item.id);
        }

        setItemsSelected([...newSelectedRows]);
    }

    const callBack = () => {
        setItemsSelected([]);
        dispatch(openStopCreateEdit(false));
        dispatch(openStopDelete(false, []))
        dispatch(openStopImport(false));
        dispatch(searchStop(driverSelected?.driverId))
    }

    return (
        <Container maxWidth={false} >
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                style={{ height: "calc(100vh - 100px)" }}
            >
                <Grid item xs={9} style={{ height: '100%' }} className='fsmRoutes' >
                    {driverSelected?.driverId &&
                        <Toolbar>
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                style={{ paddingLeft: 20 }}
                            >
                                <Grid item>
                                    <Button
                                        type="icon"
                                        icon="add_box"
                                        placement="bottom"
                                        tooltip={messages['add']}
                                        disabled={!driverSelected?.driverId}
                                        onClick={() => {
                                            dispatch(openStopCreateEdit(true));
                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    <Button
                                        type="icon"
                                        icon="delete"
                                        disabled={!itemsSelected?.length}
                                        placement="bottom"
                                        tooltip={messages['delete']}
                                        onClick={() => {
                                            dispatch(openStopDelete(true, itemsSelected))
                                        }}
                                    />
                                </Grid>

                                <Grid item>
                                    <Button
                                        type="icon"
                                        icon="ios_share"
                                        disabled={!driverSelected?.driverId}
                                        tooltip={messages['FSM_SETTINGS_ROUTE_IMPORT_TITLE']}
                                        onClick={() => {
                                            dispatch(openStopImport(true));
                                        }}
                                    />
                                </Grid>


                            </Grid>
                        </Toolbar>
                    }

                    {driverSelected?.name &&
                        <FsmAvatarDriver driver={driverSelected} />
                    }
                    <div style={{ height: 'calc(100% - 200px)', overflow: 'auto', textAlign: 'center' }}>
                        <DragDropContext onDragEnd={result => onDragEnd(result, columns, setColumns)} alwaysRenderSuggestions={true} >
                            {loading &&
                                <Loading />
                            }
                            {!loading &&
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                >

                                    {columns?.length === 0 ? '' : columns.map((column, columnId) => {
                                        return (
                                            <div className='stopStatus'>
                                                <Typography className="title-text" variant="h6">
                                                    {column?.name}
                                                </Typography>
                                                <Droppable droppableId={`${columnId}`} key={columnId}>
                                                    {(provided, snapshot) => {
                                                        return (
                                                            <List className='List-root'
                                                                {...provided.droppableProps}
                                                                ref={provided.innerRef}
                                                                style={{
                                                                    background: snapshot.isDraggingOver ? "lightblue" : "#f5f5f5",
                                                                    width: '100%',
                                                                    overflow: 'auto'
                                                                }}
                                                            >
                                                                {column?.items?.length > 0 && column?.items?.map((item, index) => {
                                                                    return (
                                                                        <Draggable
                                                                            key={`${item.id}-${columnId}`}
                                                                            draggableId={`dra${item.id}-${columnId}`}
                                                                            index={index}
                                                                            isDragDisabled={false}
                                                                        >
                                                                            {(provided, snapshot) => {
                                                                                return (
                                                                                    <RouteList
                                                                                        key={`${columnId}-${item.id}`}
                                                                                        count={index}
                                                                                        id={`${columnId}-${item.id}`}
                                                                                        provided={provided}
                                                                                        item={item}
                                                                                        checkedItem={checkedItem}
                                                                                        openMap={openMap}

                                                                                    />


                                                                                );
                                                                            }}

                                                                        </Draggable>

                                                                    );
                                                                })}
                                                                {provided.placeholder}
                                                            </List>
                                                        );
                                                    }}

                                                </Droppable>
                                            </div>
                                        );
                                    })}
                                </Grid>
                            }
                        </DragDropContext>
                    </div>

                </Grid>
                <Grid item xs={3} style={{ height: '100%' }} >
                    <div style={{ padding: 24 }}>
                        <InputSearch
                            id="search-fsm-messages"
                            searchText={searchText}
                            onSearch={handleSearch}
                            placeholder={messages['search']}
                            className="search-fsm-messages"
                        />
                        <Select
                            id="select-fsm-messages"
                            value={filterConnected}
                            onChange={(event) => {
                                setFilterConnected(event);
                            }}
                            options={optionsFilterDrivers}
                            textField="name"
                            valueField="id"
                            placeholder={`placeholder`}
                        />
                        <div style={{ height: "calc(100vh - 300px)", overflow: 'auto', textAlign: 'center', marginTop: 10 }}>
                            {loadingTimeCardDrivers && <Loading style={{ marginTop: 15 }} />}

                            {
                                lisDrivers?.length > 0 && lisDrivers?.map((row, index) => {
                                    let color = (row?.connected) ? 'fsmAvatarConnected' : '';
                                    const lastConn = getLastConnection(row, dateformat, messages, locale) 
                                    return (
                                        <div key={`fsmItem_${index}`}>
                                            <ListItem
                                                className='fsmDriverItem'
                                                onClick={(e) => {
                                                    e.preventDefault();

                                                    setColumns(optionsColum)
                                                    dispatch(searchStop(row?.driverId))
                                                    setDriverSelected(row);
                                                    setItemsSelected([])
                                                }}
                                            >
                                                <ListItemIcon>
                                                    <Avatar aria-label="recipe" className={color}>
                                                        {row?.name[0].toUpperCase()}
                                                    </Avatar>
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography color="inherit"  >
                                                        {row?.name}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary" style={{ fontSize: 12 }}>
                                                        {messages['FSM_SETTINGS_MESSAGES_LAST_CONNECTION']} {lastConn}
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <Divider />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>

                </Grid>
            </Grid>
            <SideMapComponent title={namePreview} hiddenButton />
            <RouteDelete callBack={callBack} />
            <RouteCreateEdit callBack={callBack} driver={driverSelected} />
            <ImportRoute callBack={callBack} driver={driverSelected} />

        </Container >
    );
};

export default FsmRoutes;
